import { Box, Flex, CloseButton, Center, Text } from "@chakra-ui/react";
import {
  Users,
  Files,
  Settings,
  User,
  Ticket,
  Receipt,
  Tent,
  LayoutDashboard,
  TicketCheck,
  CloudOff,
  ServerOff,
} from "lucide-react";
import MenuItem from "./MenuItem";
// @ts-expect-error: Unchecked type import
import authService from "../authorization/AuthorizeService";
import UserProfile from "../UserProfile";
import { useACL } from "@ui/components/document/DocumentACL";
import { useDocumentContext } from "@ui/context/DocumentConfigurationContext";
interface Iprops {
  handleCollapse: any;
  isOverlay: boolean;
}

const Sidebar = (props: Iprops) => {
  const { handleCollapse, isOverlay } = props;
  const { isOfflineMode, isServerReachable } = useDocumentContext();

  const { isPermitted } = useACL();
  const isSuperAdmin = isPermitted(["group:super-admin"], undefined, undefined);
  const isEmployeeAdmin = isPermitted(
    ["group:employee-admin"],
    undefined,
    undefined,
  );
  const isGuestBookingAdmin = isPermitted(
    ["group:guest-booking-admin"],
    undefined,
    undefined,
  );

  const title = ``;
  (window as any).title = title;

  return (
    <Flex
      w="full"
      h="100dvh"
      flexDirection="column"
      backgroundColor="neutrals.100"
      px={2}
      py={4}
      gap={4}
      flex={"0 0 auto"}
    >
      <Flex justifyContent={"space-between"} alignItems="center">
        <UserProfile />
        {isOverlay && <CloseButton size="sm" onClick={handleCollapse} />}
      </Flex>
      <Box
        overflowY={"hidden"}
        pr={0.5}
        flex={"1 1 auto"}
        css={{
          "&::-webkit-scrollbar": {
            width: "10px",
          },
          "&::-webkit-scrollbar-track": {
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#EBECF0",
            borderRadius: "5px",
          },
        }}
      >
        <Flex flexDirection="column" justifyContent="flex-end" flex="0 1 auto">
          {(isSuperAdmin || isGuestBookingAdmin) && (
            <MenuItem
              title="Dashboard"
              icon={
                <LayoutDashboard
                  size={"14px"}
                  color="#42526E"
                  strokeWidth="1.33"
                />
              }
              to={"/"}
            />
          )}
          <MenuItem
            title="Meal Booking"
            icon={<User size={"14px"} color="#42526E" strokeWidth="1.33" />}
            to="/MealBooking"
            onClick={isOverlay && handleCollapse}
          />
        </Flex>
      </Box>
      {!isOfflineMode && isServerReachable ? (
        <Flex flexDirection="column" justifyContent="flex-end" flex="0 1 auto">
          {(isSuperAdmin || isEmployeeAdmin) && (
            <MenuItem
              title="Holiday"
              icon={<Tent size={"14px"} color="#42526E" strokeWidth="1.33" />}
              to="/Holiday"
              onClick={isOverlay && handleCollapse}
            />
          )}
          {isSuperAdmin && (
            <MenuItem
              title="Rate Code"
              icon={
                <Receipt size={"14px"} color="#42526E" strokeWidth="1.33" />
              }
              to="/RateCode"
              onClick={isOverlay && handleCollapse}
            />
          )}
          {(isSuperAdmin || isGuestBookingAdmin) && (
            <MenuItem
              title="Guest Booking"
              icon={
                <TicketCheck size={"14px"} color="#42526E" strokeWidth="1.33" />
              }
              to="/GuestBooking"
              onClick={isOverlay && handleCollapse}
            />
          )}
          {(isSuperAdmin || isGuestBookingAdmin) && (
            <MenuItem
              title="Supplier Booking"
              icon={<Ticket size={"14px"} color="#42526E" strokeWidth="1.33" />}
              to="/SupplierBooking"
              onClick={isOverlay && handleCollapse}
            />
          )}
          {isSuperAdmin && (
            <>
              <MenuItem
                title="Supplier"
                icon={<User size={"14px"} color="#42526E" strokeWidth="1.33" />}
                to="/Supplier"
                onClick={isOverlay && handleCollapse}
              />
              <MenuItem
                title="Masters"
                icon={
                  <Files size={"14px"} color="#42526E" strokeWidth="1.33" />
                }
                to="/Masters"
                onClick={isOverlay && handleCollapse}
              />
            </>
          )}
          {(isSuperAdmin || isEmployeeAdmin) && (
            <>
              <MenuItem
                title="Directory"
                icon={
                  <Users size={"14px"} color="#42526E" strokeWidth="1.33" />
                }
                to="/Directory"
                onClick={isOverlay && handleCollapse}
              />
            </>
          )}
          {isSuperAdmin && (
            <MenuItem
              title="Settings"
              icon={
                <Settings size={"14px"} color="#42526E" strokeWidth="1.33" />
              }
              to="/Settings"
              onClick={isOverlay && handleCollapse}
            />
          )}
        </Flex>
      ) : (
        <Center flexDir={"column"} h={"96px"} w="full" gap={2}>
          {isOfflineMode ? (
            <CloudOff size={"4.5rem"} color="#42526E" strokeWidth="1.33" />
          ) : (
            <ServerOff size={"4.5rem"} color="#42526E" strokeWidth="1.33" />
          )}
          <Text color="#42526E">
            {isOfflineMode ? "Offline Mode" : "Server not reachable"}
          </Text>
        </Center>
      )}
    </Flex>
  );
};

export default Sidebar;
